module.exports = __webpack_public_path__ + "static/media/nfo_info_cover.8906cdc9.png";